/// <amd-module name="Build/RemoteServices/BuildPageData" />
import { RunDetailsData, RunPipelineData } from "Build/Client/Contracts/DataProvider";
import { ServiceOptions, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

/**
 * Contextual information for a build page
 */
export interface IRunDetailsData {

    /**
     * The currently selected build result when on a build page
     */
    build?: RunDetailsData;

    /**
     * The currently selected build definition when on a build page
     */
    definition?: RunPipelineData;
}

/**
 * Service exposing TFS data from the current page to external content
 */
class BuildPageDataService extends VssService {

    /**
     * Gets information about the currently selected project for the page
     */
    public getBuildPageData(): IRunDetailsData {

        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const result = {} as IRunDetailsData;

        // Build result page
        const pageData = contributionService.getData<RunDetailsData>("ms.vss-build-web.run-details-data-provider");
        if (pageData) {
            result.build = pageData;
            result.definition = pageData.pipeline;
        }

        return result;
    }
}

Services.add("ms.vss-build-web.build-page-data-service", { serviceFactory: BuildPageDataService, options: ServiceOptions.Remotable });
